module.exports = __webpack_public_path__ + "img/Edit-fill.eee696f6.svg";